import styles from './styles.module.scss';

export const TabLabel = ({ title, count }) => (
  <div>
    {title} {count !== null && <span className={styles.tabsCount}>({count})</span>}
  </div>
);
